const convertSizeToPx = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  switch (size) {
    case 'small':
      return 24;
    case 'large':
      return 42;
    default:
      break;
  }
  return 32;
};
export default convertSizeToPx;